export default "__VITE_ASSET__fd3ed151__"